import { render, staticRenderFns } from "./localLifeAllOrders.vue?vue&type=template&id=bfd02298&scoped=true&"
import script from "./localLifeAllOrders.vue?vue&type=script&lang=js&"
export * from "./localLifeAllOrders.vue?vue&type=script&lang=js&"
import style0 from "./localLifeAllOrders.vue?vue&type=style&index=0&id=bfd02298&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd02298",
  null
  
)

export default component.exports